import { IAdvertIcon } from "../../../Interfaces/Advert/IAdvertIcon";

export interface AdvertCardItemInterface {
	index_id: number,
	type: string,
	name: string,
	description: string,
	place: object,
	locations: object,
	deadlineText: string,
	deadline: string,
	tags: any[],
	is_advert_flag: boolean,
	slug: string,
	wage: string,
	wage_type: string,
	thumbnail: string|null,
	is_thumbnail: boolean,
	is_icons: boolean,
	is_logo: boolean,
	advert_state: string,
	icons: IAdvertIcon[],
}

export class AdvertCardItemClass implements AdvertCardItemInterface {
	index_id = -1;
	type = '';
	name = '';
	place = [];
	locations = [];
	description = '';
	deadlineText = '';
	deadline = '';
	tags = [];
	is_advert_flag = false;
	slug = '';
	wage = '';
	wage_type = '';
	thumbnail = null;
	is_thumbnail = false;
	is_icons = false;
	is_logo = false;
	advert_state = 'inactive';
	icons = [];
}
